import LayoverClient, { Entry, FlushResult } from '@/logging/LayoverClient';

// Turns client into no-ops, so no entries are collected or sent
export default class LayoverNoopClient implements LayoverClient {
  /* eslint-disable no-unused-vars, @typescript-eslint/no-unused-vars */
  send(entry: Entry): boolean {
    return false;
  }

  sendNow(entry: Entry): boolean {
    return false;
  }

  flush(): Promise<FlushResult> {
    return Promise.resolve({ sentToServer: false });
  }
  /* eslint-enable no-unused-vars, @typescript-eslint/no-unused-vars */
}
